/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
function a(a,n,c){return a.canvas||(a.canvas=document.createElement("canvas")),a.canvas.width=n,a.canvas.height=c,a.canvas}export{a as getTextHelperCanvas};
